"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import dispatcher from "./../dispatcher";
import Toast from "vwa/components/Toast";

import {getUserId} from "./../utils/user";

async function addEventDescriptor(eventDescriptor){
	console.log("eventDescriptor", eventDescriptor);
	try {
		const response = await api.post("eventDescriptors", {
			eventDescriptors: [eventDescriptor]
		});
		dispatcher.dispatch("createEventDescriptor", response.eventDescriptors[0]);
		return response.eventDescriptors[0]._id;
	} catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
	return null;
}

export default async function addNotificationConfig(eventDescriptor, notificationConfig) {
	const eventDescriptorId = await addEventDescriptor(eventDescriptor);
	if(!eventDescriptorId){
		return false;
	}

	try {
		const userId = getUserId();
		if(!userId){
			return;
		}
		
		const response = await api.post("users/notifications", {
			_id: getUserId(),
			notifications: [{
				descriptor: eventDescriptorId,
				web: notificationConfig.web,
				email: notificationConfig.email,
				sms: notificationConfig.sms
			}]
		});
		dispatcher.dispatch("createNotificationConfig", response.notifications[0]);
		return true;	
	} catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/api/addNotificationConfig.js